import * as React from 'react';

import arrayMove from 'array-move';

import { SortableContainer, SortEnd } from 'react-sortable-hoc';

import SimpleTrack from '@common/types/release/simple-track';
import { AssetUpload } from '@webapp/types/assets/asset-upload';
import { UpdateTrackOrder } from '@webapp/store/tracks/action-creators';
import { TrackOrderUpdate } from '@services/track/types/track-order-update';

import TrackUploadItem from '../track-upload-list/track-upload-item';
import { AssetValidationResults } from '@services/asset/types/asset-validation-results';
import styled from 'styled-components';
import { SimpleRelease } from '@common/types/release/simple-release';

interface TrackUploadItemsProps {
  className?: string;
  tracks: [
    SimpleTrack,
    AssetUpload | undefined,
    string,
    AssetValidationResults | undefined
  ][];
  activeRelease?: SimpleRelease;
  releaseId?: string;
  artistId?: string;
  disabled?: boolean;
  location: any;
  updateOrder: (order: TrackOrderUpdate[]) => UpdateTrackOrder;
  onRemove: (trackId: string, isActive: boolean) => void;
  onCancel: (id?: string) => void;

  disableRemove?: boolean;
  routePrefix?: string;
  disableSorting?: boolean;
}

export const TrackUploadItems: React.FC<TrackUploadItemsProps> = (props) => {
  return (
    <TrackList>
      {props.tracks.map(([track, asset, title, assetStatus], i) => (
        <TrackUploadItem
          key={`track-${track.id}`}
          index={i}
          trackId={track.id}
          title={title}
          trackLength={''}
          hasNFTSwitch={false}
          order={track.order}
          isInstrumental={track.type === 'instrumental'}
          isExplicit={!!track.isExplicit}
          isClean={!!track.isClean}
          isUploading={asset?.status === 'uploading'}
          hasErrors={!!track.source && !assetStatus?.isValid}
          progress={asset?.progress || 0}
          assetId={asset?.id || track.id}
          artistId={props.artistId}
          releaseId={props.releaseId}
          location={props.location}
          disabled={props.disabled}
          onRemove={props.onRemove}
          onCancel={() => props.onCancel(asset?.id)}
          disableRemove={props.disableRemove}
          routePrefix={props.routePrefix}
          disableSorting={props.disableSorting}
        />
      ))}
    </TrackList>
  );
};

const SortableTrackSidebar =
  SortableContainer<TrackUploadItemsProps>(TrackUploadItems);

const ConnectedTrackSideBar = (props: TrackUploadItemsProps) => {
  if (props.disableSorting) {
    return <TrackUploadItems {...props} />;
  }

  const updateTracksOrder = ({ oldIndex, newIndex }: SortEnd) => {
    const tracks = props.tracks.map((t) => t[0]);
    const newTracks = arrayMove(tracks, oldIndex, newIndex);
    const newOrder = newTracks.map((t, i) => ({
      id: t.id as string,
      order: i + 1,
    }));

    props.updateOrder(newOrder);
  };

  return (
    <SortableTrackSidebar
      {...props}
      lockAxis="y"
      useDragHandle
      helperClass="sorting"
      lockToContainerEdges={true}
      onSortEnd={(newSort) => updateTracksOrder(newSort)}
    />
  );
};

export default ConnectedTrackSideBar;

const TrackList = styled.div`
  margin-top: 3px;
  display: grid;
  grid-gap: 3px;
`;
